import { authFetch } from "../../auth";

export function formatCustomerLabel(customer) {
  if (!customer) return "-";
  return `${customer.name || customer.code || `#${customer.id}`}${customer.code ? ` / ${customer.code}` : ""}`;
}

export function formatDeviceLabel(device) {
  if (!device) return "-";
  const vehicle = device.vehicleNo || "未登记车牌";
  return `${vehicle} / ${device.deviceNo}`;
}

export function findCustomerName(customers, customerId) {
  if (customerId == null) return "-";
  const customer = customers.find((item) => Number(item.id) === Number(customerId));
  return customer ? formatCustomerLabel(customer) : `#${customerId}`;
}

export async function fetchCustomerOptions() {
  const res = await authFetch("/api/customers/options");
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "客户列表加载失败");
  }

  const data = await res.json();
  return Array.isArray(data?.items) ? data.items : [];
}

export async function fetchGroupOptions(customerId) {
  if (!customerId) return [];

  const qs = new URLSearchParams({
    page: "1",
    pageSize: "200",
    customerId: String(customerId)
  });
  const res = await authFetch(`/api/groups?${qs.toString()}`);
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "分组列表加载失败");
  }

  const data = await res.json();
  return Array.isArray(data?.items) ? data.items : [];
}

export async function fetchDeviceOptions({ customerId, groupId } = {}) {
  const qs = new URLSearchParams({
    page: "1",
    pageSize: "200"
  });

  if (customerId) qs.set("customerId", String(customerId));
  if (groupId) qs.set("groupId", String(groupId));

  const res = await authFetch(`/api/devices?${qs.toString()}`);
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "车辆列表加载失败");
  }

  const data = await res.json();
  return Array.isArray(data?.items) ? data.items : [];
}
